;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="860b7efb-c601-415b-936e-867c8c47ff35",e._sentryDebugIdIdentifier="sentry-dbid-860b7efb-c601-415b-936e-867c8c47ff35")}catch(e){}}();import events from 'events-bus';
import { useState, useEffect } from 'react';
import { AUTH_READY, AUTH_SUCCESS_EVENT, AUTH_LOGOUT_EVENT, AUTH_FAILURE_EVENT } from '../utils/constants.js';
import '../_virtual/_sentry-release-injection-file.js';

function useLogin() {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [customerStatusLoaded, setCustomerStatusLoaded] = useState(false);
    const [customerId, setCustomerId] = useState(-1);
    useEffect(() => {
        events.on(AUTH_READY, () => {
            setCustomerStatusLoaded(true);
        });
        events.on(AUTH_SUCCESS_EVENT, (_eventName, data) => {
            setCustomerId(data.payload.customerId);
            setIsLoggedIn(true);
        });
        events.on(AUTH_LOGOUT_EVENT, () => {
            setIsLoggedIn(false);
            setCustomerId(-1);
        });
        events.on(AUTH_FAILURE_EVENT, () => {
            setIsLoggedIn(false);
            setCustomerStatusLoaded(true);
        });
    }, []);
    return [isLoggedIn, customerId, customerStatusLoaded];
}

export { useLogin };
//# sourceMappingURL=useLogin.js.map
